// Keeps the header navigation (hover flyouts included) from being reachable by mouse or keyboard while the a11y
// consent view is visible. The consent view itself only marks itself `aria-hidden` for screen readers, which does
// not stop the header's CSS-only `:hover` flyouts from opening for sighted mouse users.
export default function (): void {
  const header = document.querySelector<HTMLElement>('.header');
  const view = document.querySelector<HTMLElement>('[data-a11y-consent-view]');

  if (!header || !view) {
    return;
  }

  // Reacting to EXT:a11y_consent's own `show`/`hidden` emitter events is unreliable: its footer script runs (and may
  // already emit `show`) before this deferred script even registers a listener. Watching the `aria-hidden` attribute
  // directly is timing-independent and also catches the view already being open by the time this runs.
  // a11y-dialog only ever sets `aria-hidden="true"` while hidden; on show it removes the attribute entirely rather
  // than setting it to "false", so absence of the attribute (or any value other than "true") counts as shown.
  const sync = (): void => {
    if (view.getAttribute('aria-hidden') === 'true') {
      header.removeAttribute('inert');
    } else {
      header.setAttribute('inert', '');
    }
  };

  new MutationObserver(sync).observe(view, {attributes: true, attributeFilter: ['aria-hidden']});
  sync();
}